import { call, put, takeEvery, all } from "redux-saga/effects";
import * as types from "../types";
import {
  performPasswordChange,
  retrieveUserFullName,
  updateUserDetails,
  retrieveUserDetails,
  retrieveUserLogins,
  updateUserImage,
  deleteUserImage,
  retrieveUserImage,
  retrieveCompanyList,
  acceptInvitation,
  rejectInvitation,
  updateUnseenNotifications,
  retrieveNotificationsList,
} from "../../networking/profile/networking";

function* fetchUserDetails(action) {
  try {
    if (action.payload) {
      const details = yield call(retrieveUserDetails, action.payload);
      if (details.error === null) {
        yield put({ type: types.SET_USER_DETAILS, user: details.payload });
        if (details.payload.companies && details.payload.companies[0]) {
          yield put({
            type: types.SET_ACTIVE_COMPANY,
            company: details.payload.companies[0],
          });
          yield put({ type: types.HIDE_NO_COMPANY_POPUP, status: false });
        } else {
          yield put({ type: types.SET_ACTIVE_COMPANY, company: null });
          yield put({ type: types.HIDE_NO_COMPANY_POPUP, status: true });
        }
      } else {
        throw new Error("Kunne ikke hente brukerinformasjon.");
      }
    } else {
      throw new Error("Kunne ikke hente brukerinformasjon.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_USER_DETAILS, message: e });
  }
}

function* performUpdateUserInfo(action) {
  try {
    if (action.details) {
      var response = yield call(updateUserDetails, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_USER_INFO });
      } else {
        throw new Error("Kunne ikke slette kunde.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_USER_INFO, message: e });
  }
}

function* performUpdateUserGeneral(action) {
  try {
    if (action.payload) {
      var response = yield call(updateUserDetails, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_USER_GENERAL });
      } else {
        throw new Error("Kunne ikke slette kunde.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_USER_GENERAL, message: e });
  }
}

function* performRetrieveFullName(action) {
  try {
    if (action.payload) {
      var response = yield call(retrieveUserFullName, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_USER_FULL_NAME, data: response.payload });
      } else {
        throw new Error("Kunne ikke hente fullt navn.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_USER_FULL_NAME, message: e });
  }
}

function* performUpdatePassword(action) {
  try {
    if (action.details) {
      var response = yield call(performPasswordChange, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_USER_PASSWORD });
      } else {
        throw new Error("Kunne ikke oppdatere passord.");
      }
    } else {
      throw new Error("Kunne ikke oppdatere passord.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_USER_PASSWORD, message: e });
  }
}

function* fetchUserLogins(action) {
  try {
    if (action.payload) {
      const history = yield call(retrieveUserLogins, action.payload);
      if (history.error === null) {
        yield put({ type: types.SET_USER_LOGINS, logins: history.payload });
      } else {
        throw new Error("Kunne ikke hente innlogginger.");
      }
    } else {
      throw new Error("Kunne ikke hente innlogginger.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_USER_LOGINS, message: "failed" });
  }
}

function* performUpdateImage(action) {
  try {
    if (action.details) {
      const status = yield call(updateUserImage, action.details);
      if (status.error === null) {
        yield put({ type: types.GRANT_UPDATE_USER_IMAGE });
      }
    } else {
      throw new Error("Kunne ikke oppdatere bilde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_USER_IMAGE, message: e });
  }
}

function* performDeleteImage(action) {
  try {
    if (action.details) {
      const response = yield call(deleteUserImage, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_USER_IMAGE });
      }
    } else {
      throw new Error("Kunne ikke slette bilde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_USER_IMAGE, message: e });
  }
}

function* performRetrieveImage(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveUserImage, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_USER_IMAGE, image: response.payload });
      } else {
        throw new Error("Kunne ikke hente bilde.");
      }
    } else {
      throw new Error("Kunne ikke hente bilde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_USER_IMAGE });
  }
}

function* performRetrieveCompanies(action) {
  try {
    if (action.payload) {
      const companies = yield call(retrieveCompanyList, action.payload);
      if (companies) {
        yield put({
          type: types.SET_USER_COMPANIES,
          companies: companies.list,
        });
      } else {
        throw new Error("Kunne ikke hente selskaper.");
      }
    } else {
      throw new Error("Kunne ikke hente selskaper.");
    }
  } catch (e) {
    yield put({ type: types.RESET_USER_COMPANIES });
  }
}

function* performAcceptInvitation(action) {
  try {
    if (action.payload) {
      const response = yield call(acceptInvitation, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_ACCEPT_INVITATION });
      } else {
        throw new Error(response.error);
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({ type: types.REVOKE_ACCEPT_INVITATION, message: errMessage });
  }
}

function* performRejectInvitation(action) {
  try {
    if (action.payload) {
      const response = yield call(rejectInvitation, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_REJECT_INVITATION });
      } else {
        throw new Error(response.error);
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({ type: types.REVOKE_REJECT_INVITATION, message: errMessage });
  }
}

function* performUpdateUnseenNotifications(action) {
  try {
    if (action.payload) {
      const response = yield call(updateUnseenNotifications, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_UNSEEN_NOTIFICATIONS });
      } else {
        throw new Error(response.error);
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({
      type: types.REVOKE_UPDATE_UNSEEN_NOTIFICATIONS,
      message: errMessage,
    });
  }
}

function* performFetchNotifications(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveNotificationsList, action.payload);
      if (response.error === null) {
        yield put({
          type: types.GRANT_FETCH_NOTIFICATIONS,
          notifications: response.payload,
        });
      } else {
        throw new Error(response.error);
      }
    }
  } catch (e) {
    const errMessage = e.toString().replace("Error:", "");
    yield put({ type: types.REVOKE_FETCH_NOTIFICATIONS, message: errMessage });
  }
}

function* userSaga() {
  yield all([
    yield takeEvery(types.REQUEST_USER_DETAILS, fetchUserDetails),
    yield takeEvery(types.REQUEST_UPDATE_USER_INFO, performUpdateUserInfo),
    yield takeEvery(
      types.REQUEST_UPDATE_USER_GENERAL,
      performUpdateUserGeneral
    ),
    yield takeEvery(types.REQUEST_USER_FULL_NAME, performRetrieveFullName),
    yield takeEvery(types.REQUEST_UPDATE_USER_PASSWORD, performUpdatePassword),
    yield takeEvery(types.REQUEST_USER_LOGINS, fetchUserLogins),
    yield takeEvery(types.REQUEST_UPDATE_USER_IMAGE, performUpdateImage),
    yield takeEvery(types.REQUEST_DELETE_USER_IMAGE, performDeleteImage),
    yield takeEvery(types.REQUEST_USER_IMAGE, performRetrieveImage),
    yield takeEvery(types.REQUEST_USER_COMPANIES, performRetrieveCompanies),
    yield takeEvery(types.REQUEST_ACCEPT_INVITATION, performAcceptInvitation),
    yield takeEvery(types.REQUEST_REJECT_INVITATION, performRejectInvitation),
    yield takeEvery(
      types.REQUEST_UPDATE_UNSEEN_NOTIFICATIONS,
      performUpdateUnseenNotifications
    ),
    yield takeEvery(
      types.REQUEST_FETCH_NOTIFICATIONS,
      performFetchNotifications
    ),
  ]);
}

export default userSaga;
